export default ({ get, checkStatus, toJSON }) => ({
  search: (query) =>
    get(`universe/search?query=${query}`).then(checkStatus).then(toJSON),
  getSchools: (query) =>
    get(`universe/v1/search/schools_improved/?q=${query}`)
      .then(checkStatus)
      .then(toJSON),
});
